module["exports"] = [
  "zu",
  "von",
  "vom",
  "von der"
];



//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/de/name/nobility_title_prefix.js
// module id = 485
// module chunks = 0